import { ClientTreeUpdated } from "event-definitions"
import { getFacilities } from "routes/facilities/lib/use-root-facilities"

export function useFacilities(tree) {
    ClientTreeUpdated.after.useRefresh()
    return tree ? getFacilities(tree, true) : undefined
}
